import { api } from "@/utils/api";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "@/features/user/userSlice";
import { useDispatch } from "react-redux";
import { useRef, useState } from "react";
import { toast } from "@/utils/appToast";
import { JandiSymbol } from "@/components/assets/logos/svgs";
import { StorageI } from "@/types/interfaces";
import { SetStorage, setAuthentication } from "@/shared/services/credentialsService";
import Checkbox from "@/shared/checkbox/checkbox";
import { initPushNotifications } from "@/utils/pushUtils";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import GoogleSignIn from "@/utils/googleSignIn";
import { isWorkerProfileComplete } from "@/utils/workerProfileUtils";



type LoginProps = {
  handlePopupType: (type: string) => void;
  setUserId: (id: string) => void;  // ✅ function passed from parent
};


const Login = ({ handlePopupType, setUserId }: LoginProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [userData , setUserData] = useState({})
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  // Email validation function
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLogIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const loginForm = e.target as HTMLFormElement;
    const loginData = new FormData(loginForm);
    const email = loginData.get("email") as string;

    // Validate email before proceeding
    if (!validateEmail(email)) {
  toast.error(t("toastValidEmail"));
      return;
    }

    // Get the remember me checkbox value
    const rememberMe = loginData.get("remember-me") === "on";

    try {
    setIsLoading(true);
    const res = await api.signIn({
      email: email,
      password: loginData.get("password") as string,
    })

    if(res && res.status === 403){
      toast.error(res?.message)
      setIsLoading(false);
      return
    }
    
      if(res && res.success === true){
      setUserData(res.data)
      const storageData: StorageI = {
        data: {
          token: res?.data?.token,
          user: res?.data?.user
        }
      };
      SetStorage(storageData, rememberMe);
   const { token, user } = res?.data;
if (res?.data?.user?.forcePasswordReset) {
  console.log("working");

  // ✅ Update userId + switch popup together
  setUserId(res?.data?.user?._id);
  setTimeout(() => {
    handlePopupType("ResetPassword");
  }, 0);

  return;
}


        dispatch(loginUser({ token, user }));

        if (!res?.data?.user?.isEmailVerified){
          toast.error(t("toastUnverifiedEmail"))
          setIsLoading(false);
          return
        }
        
        await initPushNotifications()
        
        if (res?.data?.user?.type === "worker") {
          // Check worker profile completeness
          const workerProfile = await api.getMyWorkerProfile();
          if(workerProfile){
            // Check if profile is complete using helper function
            if (!isWorkerProfileComplete(workerProfile)) {
              setIsLoading(false);
              handlePopupType('Close');
              navigation("/settings");
              return;
            }
          }
          
          // If profile is complete, proceed with normal worker flow
          setAuthentication(true, rememberMe);
          navigation('/my-jobs')
          toast.success(t("toastLoginSuccessful"))
        } else {
          // For normal users, set authenticated immediately
          setAuthentication(true, rememberMe);
          toast.success(t("toastLoginSuccessful"))
        }
        handlePopupType('Close')
    }
    else  {
      toast.error(res.message)
      setIsLoading(false);
      return
    }
  
  } catch (err) {
    setIsLoading(false);
  }
   
  };

  const checkWorkerProfile = async () => {
    try {
      const workerProfile = await api.getMyWorkerProfile();
      console.log(workerProfile);
 
      const isStripeOnBoardingCompleted = workerProfile?.isStripeOnBoardingCompleted;
      if (!isStripeOnBoardingCompleted) {
        // const onboardingLink = await api.getAccountLink();

        const { status, data } = await api.getAccountLink();
        if (status === "error") {
          setIsLoading(false);
          setAuthentication(false);
          toast.error(data.message);
          return false;
        }
        const onboardingLink = data?.data
        window.location.href = onboardingLink;
        return true;
      }
     
     
    } catch (err) {
      setAuthentication(false);
      throw err;
    }
  };

  return (
    <div className="login-form default-form">
      <div className="form-inner">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
            // marginTop: 20,
          }}
        >
          {/* <JandiSymbol alt /> */}
          <img
            src="/images/phone_symbol.svg"
            alt="Phone Symbol"
            style={{
              width: '60px',
              height: '60px',
              display: 'block'
            }}
          />
        </div>

        
      <h3 className="text-center" style={{ color: "white", fontWeight: 600 }}>Jandi - {t('login')}</h3>

        {/* Hidden Button to Close Modal */}
        {/* <button className="d-none" data-bs-dismiss="modal" ref={closeModalBtn}>
        Close modal
      </button> */}

        {/* <!--Login Form--> */}
        <form method="post" onSubmit={handleLogIn}>
          <div className="form-group">
            <label style={{ color: "white" }}>
              {t('userEmail')} <span style={{ color: "red" }}> *</span>
            </label>
            <input
              style={{ borderRadius: 0 }}
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('email')}
              required
            />
          </div>
          {/* email */}

        <div className="form-group" style={{ position: "relative" }}>
    <label style={{ color: "white" }}>
        {t('password')} <span style={{ color: "red" }}> *</span>
    </label>

    <div style={{ position: "relative" }}>
        <input
            style={{ width: "100%", borderRadius: 0 }}
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder={t('password')}
            required
        />

        <IconButton
            onClick={() => setShowPassword((prev) => !prev)}
            style={{
                position: "absolute",
                right: 5,
                top: "50%",
                transform: "translateY(-50%)",
                padding: 0,
                color: "black",
            }}
        >
            {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
    </div>
</div>

          {/* password */}

          <div className="form-group">
              <div className="flex items-center justify-between">
              <Checkbox
                name="remember-me"
                id="remember"
                label={t('rememberMe')}
                labelClass="remember"
              />
              <a
                style={{ color: "white",textAlign: "right" }}

                className="pwd"
                onClick={() => handlePopupType('ForgotPassword')}
              >
                {t('forgotPassword')}
              </a>
              </div>
          </div>

          <div className="form-group">
            <button
              className="theme-btn btn-style-one mb-0"
              type="submit"
              name="log-in"
              disabled={isLoading}
              style={{ backgroundColor: "black" }}
            >
              {isLoading ? (
                <div
                  className="spinner-border"
                  style={{ height: "15px", width: "15px" }}
                  role="status"
                ></div>
              ) : (
                t('login')
              )}
            </button>
          </div>
        </form>

        {/* Google Sign-In */}
        <div className="form-group" style={{ marginTop: "15px" }}>
          <GoogleSignIn
            onSuccess={async ({ user, workerProfile, workerProfileIncluded }) => {
              const rememberMe = true;

              if (!user?.isEmailVerified) {
                toast.error(t("toastUnverifiedEmail"));
                return;
              }

              if (user?.type === "worker") {
                try {
                  let profile = workerProfileIncluded ? workerProfile : undefined;
                  if (!workerProfileIncluded) {
                    profile = await api.getMyWorkerProfile();
                  }
                  if (profile && !isWorkerProfileComplete(profile)) {
                    handlePopupType('Close');
                    navigation("/settings");
                    return;
                  }
                } catch (err) {
                  console.error("Error fetching worker profile:", err);
                }
              }

              void initPushNotifications();

              if (user?.type === "worker") {
                setAuthentication(true, rememberMe);
                navigation('/my-jobs');
                toast.success(t("toastLoginSuccessful"));
              } else {
                setAuthentication(true, rememberMe);
                toast.success(t("toastLoginSuccessful"));
              }

              handlePopupType('Close');
            }}
          />
        </div>
        {/* End bottom-box LoginWithSocial */}
      </div>
    </div>
  );
};

export default Login;
